export default "__VITE_ASSET__CQlxgc5t__"